/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Notes({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Notes",
  onChange,
  isInvalid,
  onSubmit
  
}) {
let newProfessionalOtherPersonNoteValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'other.person.note',
})
let newProfessionalOtherPersonNoteChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'other.person.note',
})
let newProfessionalOtherPersonNoteSubmitData = fromData.useDataSubmit({ viewPath,
context: 'new_professional',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Notes"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 data="new_professional.other.person.note"
 placeholder="Notes"
 onChange={newProfessionalOtherPersonNoteChangeData}
 value={newProfessionalOtherPersonNoteValueData}
 isInvalid={!undefined}
 onSubmit={newProfessionalOtherPersonNoteSubmitData}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}